import type { AuthProvider } from "@/types";

import { apiAuthProvider } from "./auth.api";

export const authService: AuthProvider = apiAuthProvider;
